<template>
  <div>
    <!--el-nav-bar></el-nav-bar-->

    <div id="main">
      <router-view></router-view>

      <el-divider class="divider-footer"></el-divider>

      <el-footer></el-footer>
    </div>
  </div>
</template>

<script>
import ElFooter from "./views/layouts/ElFooter";

export default {
  components: {
    ElFooter
  },
  data() {
    return {
      activeIndex: '1',
      activeIndex2: '1'
    };
  },
  methods: {},
  watch: {
    $route: {
      immediate: true,
      handler() {
        document.title = 'Calculadora Ichimoku Fibonacci!';
      }
    },
  }
}
</script>
<style>
.footer-wrap {
  margin-bottom: 20px;
}
.divider-footer {
  margin-bottom: 0;
}
#main {
  padding: 80px;
}

@media (max-width: 1220px) {
  #main {
    padding: 0;
  }
}
</style>


